<pds-modal #modal title="Associar NF-e" [width]="520">
  <main class="modal__content">
    <div class="modal__content__form">
      <form [formGroup]="form">
        <pds-form-field label="Insira o Nº da NF-e">
          <pds-autocomplete placeholder="Busque pela nota" formControlName="invoice" [source]="invoices$" (autocomplete)="onAutoCompleteInvoice($event)" />
        </pds-form-field>
      </form>
      <p>Esta ação não poderá ser desfeita. Deseja continuar?</p>
    </div>

    <pds-form-actions>
      <button pdsButton [disabled]="form.invalid" (click)="onClickConfirm()" type="button">Associar</button>
    </pds-form-actions>
  </main>
</pds-modal>
